module.exports = __webpack_public_path__ + "img/fig11.366e472c.jpg";